module.exports = ".manage-purchase-order-table tr th:first-child, .manage-purchase-order-table tr td:first-child {\r\n  text-align: center !important;\r\n}\r\n.manage-purchase-order-table tr td:first-child label {\r\n    margin-bottom: 0;\r\n  }\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/order-components/order-list/order-list.component.css
// module id = ./src/app/order-components/order-list/order-list.component.css
// module chunks = main